<section class="breadcrumb-area mt-0 py-4">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-box text-center">
          <h1>{{h1 | uppercase}}</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="category pt-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="product-box">
          <div class="cat-box d-flex justify-content-end">
            <div style="display: flex!important;padding-right: 25px;">
              <!--<div class="sortby" style="margin-right: 20px;">
                <span>Sort By</span>
                <select class="sort-box">
                  <option>Position</option>
                  <option>Name</option>
                  <option>Price</option>
                  <option>Rating</option>
                </select>
              </div>-->
<!--              <div class="show-item" style="margin-right: 20px;">-->
<!--                <span>Mostrar</span>-->
<!--                <select class="show-box" #selectItems>-->
<!--                  <option selected>8</option>-->
<!--                  <option>12</option>-->
<!--                  <option>24</option>-->
<!--                </select>-->
<!--              </div>-->
             <!--  <div class="page">
                <p>Page {{pageNo$ | async}} of {{totalPages$ | async}}</p>
              </div> -->
<!--              <div  class="page">-->
<!--                <p>Mostrando {{count$ | async}} de {{totalData$ | async}} resultados</p>-->
<!--              </div>-->
            </div>

          </div>
          <div class="tab-content">
            <div class="tab-pane active">
              <div class="row">
                <ng-container *ngIf="isLoading$ | async ; else template">
                  <div *ngFor="let product of [1,2,3,4,5,6,7,8]" style="display:flex;" class="col-lg-3 col-md-4 col-6">

                   <div class="tab-item w-100 rounded-xl">
                      <div class="tab-img mb-5">
                        <ngx-skeleton-loader animation="progress" animation="true" appearance="line"
                                             [theme]="{ height: 'auto',background: '#f1f1f1', 'padding-bottom':'80%'}">
                        </ngx-skeleton-loader>
                        <div class="w-100 position-relative d-flex justify-content-center">
                          <div class="position-absolute preview-url d-flex justify-content-center align-items-center">
                            <ngx-skeleton-loader animation="progress" appearance="circle"
                                                 [theme]="{ width: '40px', height: '40px',background: '#f1f1f1', top:'3px'}">
                            </ngx-skeleton-loader>
                          </div>
                        </div>

                      </div>

                      <div class="tab-heading d-flex justify-content-center">
                        <ngx-skeleton-loader style="width: 80%" animation="progress" appearance="line"
                          [theme]="{ margin: '-15px 0 0 0', height: '28px',background: '#f1f1f1'}">
                        </ngx-skeleton-loader>
                      </div>

                        <div class="img-content d-flex justify-content-center">
                          <ngx-skeleton-loader style="width: 50%" animation="progress" appearance="line"
                            [theme]="{ margin: '5px 0 0 0px', height: '18px',background: '#f1f1f1'}">
                          </ngx-skeleton-loader>
                        </div>

                      <div class="img-content d-flex justify-content-center">
                        <ngx-skeleton-loader style="width: 70%" animation="progress" appearance="line"
                          [theme]="{ height: '32px',background: '#f1f1f1', 'border-radius': '50rem'}">
                        </ngx-skeleton-loader>
                      </div>

                     </div>

                  </div>
                </ng-container>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="items$ | async" class="d-flex justify-content-center p-0 paginated">
  <ngb-pagination [pageSize]="pageSize$ | async" [collectionSize]="totalData$ | async" (pageChange)="pageChange($event)" [page]="pageNo$ | async"></ngb-pagination>
</section>
<ng-template #template>
  <ng-container *ngFor="let store of items$ | async; let index = index;">
    <div style="display:flex;" class="col-lg-3 col-md-4 col-6">
      <div class="tab-item w-100 rounded-xl">

        <div class="tab-img position-relative d-flex align-items-center justify-content-center mb-5">

          <ngx-skeleton-loader [hidden]="store.loaded" animation="progress" appearance="line" [theme]="theme">
          </ngx-skeleton-loader>

          <img style="width: 100%; height:198px;" [hidden]="!store.loaded" class="main-img img-fluid store-img" routerLink="{{store.code}}"
            src="{{store.pictures .length>0?store.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
            (load)="store.loaded=true">

          <div class="position-absolute preview-url d-flex justify-content-center align-items-center">

            <ngx-skeleton-loader [hidden]="store.iconloaded" animation="progress" appearance="circle"
              [theme]="{ width: '40px', height: '40px',background: '#f1f1f1', top:'3px'}">
            </ngx-skeleton-loader>

            <img class="main-img img-fluid store-img" width="40px" height="40px" routerLink="{{store.code}}"
              src="{{store.icon? 'data:image/png;base64,' + store.icon :'assets/xemart/images/notImg.png'}}"
              (load)="store.iconloaded=true">

          </div>

        </div>

        <div style="min-height: 120px;">


          <div class="tab-heading">
            <p style="color: #000;font-size: 17px; cursor: pointer" class="text-center" routerLink="{{store.code}}">{{store.name}}</p>
            <p class="text-center">{{store.title}}</p>
          </div>
          <div class="img-content d-flex justify-content-center">
            <ul title="{{store.rating}}" *ngIf="store.rating > 0" [innerHtml]="store.rating | start" class="list-unstyled list-inline fav"></ul>
          </div>

        </div>
        <div class="img-content d-flex justify-content-center">
          <button routerLink="{{store.code}}" class="btn px-2 text-white py-1 OpenSans rounded-pill position-relative"
            style="background:#0C8EFE; font-size: 16px; width: 130px;">Ver tienda
          </button>
        </div>

      </div>
    </div>
  </ng-container>
</ng-template>
